import { CommonModule,DecimalPipe } from '@angular/common';
import { Component, inject, effect, ViewChild, ElementRef } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbDatepickerModule, NgbModule, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@services/core/user.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { NgSelectModule } from '@ng-select/ng-select';
import { BudgetFactorRefService } from './budget-factor-ref.service';
import Swal from 'sweetalert2';
import { registerLocaleData } from '@angular/common';
import { Entity } from '@model/entity.model';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID } from '@angular/core';
import { EmployeeModel } from './budget-factor-ref.model';
import { NumberFormatDirective } from '@directives/number-format.directive';

registerLocaleData(localeEs);


@Component({
  selector: 'app-budget-factor-ref',
  standalone: true,
  imports: [ CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    NgbModule,
    NumberFormatDirective
  ],
  providers: [NgbModal,{ provide: LOCALE_ID, useValue: 'es-ES' },DecimalPipe],
  templateUrl: './budget-factor-ref.component.html',
  styleUrl: './budget-factor-ref.component.css',
})
export class BudgetFactorRefComponent {
  @ViewChild('modal_diverse', { static: true }) modalDiverse: any;
  @ViewChild('ngSelectAssinet', { static: false }) ngSelectAssinet: NgSelectComponent;
  @ViewChild('ngSelect', { static: false }) ngSelect: NgSelectComponent;
  @ViewChild('nameInput') nameInput: ElementRef;
  private modalRef: NgbModalRef;
  private userService = inject(UserService);
  private budgetFactorRefService = inject(BudgetFactorRefService);
  public filter: EmployeeModel = new EmployeeModel();
  public entitySelected: Entity;
  public dataEmployeeType;
  public dataListDiverse;
  public dataNgSelectAssinet;
  public dataDiverse;  
  public dataDiverseTemp;
  public txtFind;
  public tabArea = 'diverse';
  public modalHeaderDiverse: string;
  public formDiverse: FormGroup;
  public id;
  closeResult: string;
  modalOptions = {
    animation: true,
  };
  constructor(private modalService: NgbModal, private formBuilder: FormBuilder, private decimalPipe: DecimalPipe) {

    effect(()=> {
      this.entitySelected = this.userService.sharingEntity();	
       if (this.entitySelected) {
        this.getBudgetFactor();
      }
		})
  }


  /**crear formulario reactivo diverso*/
  createFormDiverse() {
    this.formDiverse = this.formBuilder.group({
      code: ['', [Validators.required, Validators.minLength(1)]],
      name: ['', Validators.required],
      value: ['', [Validators.required]],
      decimalPlaces: ['', ],
      unitSymbol: ['', ],
      entityType:['*'],
      isEditable: [false],
    });
  }


  ngOnInit() {
    this.createFormDiverse();
  }



  /**combina los datos del formDiverso con los datos q faltan para hacer la peticion en el servicio */
  newData(data) {
    data['entityCode'] = this.entitySelected?.code;
    data['year']=this.filter.year;
    data['version']=this.filter.version
    return data;
  }

  /*mensaje de cargando */
  loading(title:string='Cargando...') {
    Swal.fire({
      title: title,
      html: 'Por favor, espere',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }




  /*trae los datos diverse en el servicio de budget  */
  getBudgetFactor() {
    this.budgetFactorRefService.getBudgetFactorRef().subscribe((res)=>{
      this.dataDiverse=res;
      this.dataDiverseTemp=JSON.parse(JSON.stringify(this.dataDiverse));
      this.dataListDiverse=this.ngSelectData(this.dataDiverseTemp);
    }, (error => console.error(error)));
  }



/**busca los diverso  */
  findEmployee(code): boolean {
    let isActive=false;
    isActive=this.dataDiverse?.some((diverse) => diverse.code === code)
    return isActive
   
	}


  /*mapea los datos del ng-select */
  ngSelectData(diverse) {
    let newData = diverse.map((d) => {
      return {
        code: d.code,
        codeName: d.code + ' - ' + d.name,
        name: d.name
      }
    });
    return newData
  }


   /**al momento de cerrar el ng select de busqueda busca actualiza la tabla de diversos  */
   onCloseNgSelectFind() {
    if(this.txtFind.length>0){
      this.dataDiverse=this.dataDiverseTemp.filter(d=>
        this.txtFind.includes(d.code)
      );
    }else{
      this.dataDiverse=this.dataDiverseTemp;
    }
  }



  blurNgSelect(){
   this.getBudgetFactor();
    
  }


  


  
  /*abre los modales */
  open(content) {
    this.modalRef = this.modalService.open(content);
  }

   /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }


  /**abre el modal del diverse */

  openModalDiverse() {
    this.modalHeaderDiverse = 'Nuevo Factor';    
    this.formDiverse.reset();
    this.formDiverse.patchValue({
      code:'',
      name:'',
      value:0,
      decimalPlaces:0,
      unitSymbol:'',
      entityType:'*',
      isEditable: false
    })
    this.formDiverse.get('code').enable();
    this.formDiverse.markAsPristine();
    this.open(this.modalDiverse);
  }


  /**carga los datos al pinchar en la tabla editar */

  setFormDiverse(params) {
    this.modalHeaderDiverse = 'Modificar Factor';
    this.id=params.id;
    this.formDiverse.patchValue({
      code:params.code,
      name:params.name,
      value:this.decimalPipe.transform(
        params.value, 
        `1.${params.decimalPlaces}-${params.decimalPlaces}`
      ),
      decimalPlaces:params.decimalPlaces,
      unitSymbol:params.unitSymbol,
      entityType:params.entityType,
      isEditable: !!params.isEditable
    })
    this.formDiverse.get('code').disable();
    this.formDiverse.markAsPristine();
    this.open(this.modalDiverse);

  }

  /**Actualiza directamente un campo con checkbox en la tabla */
  updateDiverseCheck(item: any, field: string, value: boolean) {
    this.budgetFactorRefService.updateBudgetFactorRef({ id: item.id, [field]: value }).subscribe({
      next: () => {
        item[field] = value;
      },
      error: (error) => console.error(error)
    });
  }

  /**al momento de cerrer el ng select pasa el foco al input name y le asigna el valor de name  */
  onCloseNgSelectAssinet() {   
    const selected = this.dataNgSelectAssinet.find(i => i.diverse === this.formDiverse.get('code').value)
    if(selected?.name){
      this.formDiverse.get('names').patchValue(selected.name);
      this.nameInput.nativeElement.focus();
      this.nameInput.nativeElement.select();
    }
  }


  /**cambia la fecha en formato compatible para el mostrar campo de fecha */
  setDate(date?) {
    const expirationDate = date ? new Date(date) : new Date();
    let formatDate = {
      year: date ? expirationDate.getFullYear() : expirationDate.getFullYear() + 1,
      month: expirationDate.getMonth() + 1,
      day: date ? expirationDate.getDate() : expirationDate.getDate() + 1
    };
    return formatDate
  }

  /**Elimnar diverso */
  deleteDiverse(params) {
    const loadingToast = Swal.fire({
      icon: 'warning',
      title: 'Alerta ',
      text: '¿Estás seguro de eliminar: ' + params.code + ' ' + params.name+'? Se eliminaran todos los registros del usuario incluyendo detalle de salario y de primas infantiles ',
      toast: false,
      position: 'center',
      showCancelButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      timer: null,
      timerProgressBar: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.budgetFactorRefService.deleteBudgetFactorRef(params).subscribe(res => {  
          this.getBudgetFactor();
        }, (error => console.error(error)))
      }
    });
  }


  /*envia la informacion para un nuevo diverso*/
  submitDiverseNew() {
    if (this.formDiverse.valid) {
      let data = this.newData(this.formDiverse.value);
      let rawValue = this.formDiverse.value.value ?? 0;

      // Si viene como string con separadores, lo normalizas:
      let value = typeof rawValue === 'string'
        ? parseFloat(rawValue.replace(/\./g, '').replace(',', '.'))
        : Number(rawValue);
      data['value']=value;
      this.budgetFactorRefService.saveBudgetFactorRef(data).subscribe(res => {
        this.close();     
        this.getBudgetFactor();   
      }, (error => console.error(error)))
    }
  }

  /*envia la informacion para un actualizar diverso*/
  submitDiverseUpdate() {
    
    if (this.formDiverse.valid) {
      let data = this.newData(this.formDiverse.value);
      let rawValue = this.formDiverse.value.value ?? 0;

      // Si viene como string con separadores, lo normalizas:
      let value = typeof rawValue === 'string'
        ? parseFloat(rawValue.replace(/\./g, '').replace(',', '.'))
        : Number(rawValue);
      data['value']=value;
      data['id']=this.id;
      this.budgetFactorRefService.updateBudgetFactorRef(data).subscribe(res => {   
        let employee=this.setEmployee(this.id)            
        this.close();
        this.getBudgetFactor();
      }, (error => console.error(error)))

    }
  }

  
  setEmployee(id) {
    return this.dataDiverse.find(em => em.id == id);
  }


  findEmployeetype(id) {
    const type=this.dataEmployeeType?.find(em => em.id == id);
    return type?type.name:id;
  }

  
  /*Activa o desactiva un diverso*/
  UpdateDiverseActive(params,isActive) {
    let employee=this.setEmployee(params.id)
    employee.isActive=isActive
    this.sortDiverseByIsActive();
    this.budgetFactorRefService.updateBudgetFactorRef({id:params.id,isActive:isActive}).subscribe(res => {
      const Toast = Swal.mixin({
        icon: 'success',
        title: 'Datos Actualizados',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 2500, // El toast dura 2 segundos
        timerProgressBar: true,
      });
      Toast.fire();     
    }, (error => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudieron actualizar los datos.',
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000
      });
    }))
  }

  sortDiverseByIsActive() {
        this.dataDiverse.sort((a, b) => {
       return (a.isActive === b.isActive) ? 0 : a.isActive ? -1 : 1;
    });
  }



}



